import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IRouteData } from 'src/app/models/role';
import { CurrentTenantComponent } from './current-tenant/current-tenant.component';
import { TenantOptionsComponent } from './current-tenant/tenant-options/tenant-options.component';
import { TenantDashboardComponent } from './dashboard/dashboard.component';


const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'dashboard',
                component: TenantDashboardComponent,
                data: { title: 'Tenant', menu: 'tenant' } as IRouteData
            },
            {
                path: ':name',
                data: { title: 'Tenant', menu: 'tenant' } as IRouteData,
                component: CurrentTenantComponent,
                children: [
                    {
                        path: 'option',
                        children: [
                            {
                                path: ':entity',
                                component: TenantOptionsComponent,

                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'settings_editor'
                            }
                        ]
                    },
                    {
                        path: '**',
                        redirectTo: 'option'
                    }
                ]
            },
            {
                path: '**',
                redirectTo: 'dashboard'
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
    ]
})
export class TenantRoutingModule {

}
